<template>
  <div class="home_wrap">
    <Header></Header>
    <van-row class="topSection">
      <van-col span="6" style="text-align: left">
        <router-link to="/team">
          <img src="../images/common/backArrow.png" class="imageback"
        /></router-link>
      </van-col>
      <van-col span="18" style="text-align: right">
        <span style="color: #ffffff; font-size: 30px; font-weight: 700">{{
          $t("ownProfit.topic")
        }}</span>
      </van-col>
    </van-row>
    <van-list
      v-model:loading="loading"
      :finished="finished"
      :finished-text="$t('bonus.loadFinish')"
      @load="getMyInvestmentsList"
    >
      <van-row style="padding: 10px" v-for="item in investList" :key="item.id">
        <van-row class="profitBox">
          <van-row>
            <van-col span="24">
              <img :src="item.image" class="movieTopImage" />
            </van-col>
          </van-row>
          <!-- --------- name ------ -->
          <van-row style="padding-top: 25px">
            <van-col span="12">
              <p class="profitTopic">{{ $t("ownProfit.name") }}</p>
            </van-col>
            <van-col span="12" style="text-align: right">
              <p class="profitValue">{{ item.name }}</p>
            </van-col>
          </van-row>

          <!-- --------- days ------ -->
          <van-row style="padding-top: 25px">
            <van-col span="12">
              <p class="profitTopic" style="word-break: break-word;">{{ $t("ownProfit.days") }}</p>
            </van-col>
            <van-col span="12" style="text-align: right">
              <p class="profitValue">{{ item.countdown }} {{ item.countdown > 1 ? $t("movieInvest.days") : $t("rewardRulesTabOne.day") }}</p>
            </van-col>
          </van-row>

          <!-- --------- income ------ -->
          <van-row style="padding-top: 25px">
            <van-col span="12">
              <p class="profitTopic">{{ $t("ownProfit.dailyIncome") }}</p>
            </van-col>
            <van-col span="12" style="text-align: right">
              <p class="profitValue">
                $ {{ item.total_daily_return_amount }}
              </p>
            </van-col>
          </van-row>

          <!-- --------- expected investment ------ -->
          <van-row style="padding-top: 25px">
            <van-col span="12">
              <p class="profitTopic">
                {{ $t("ownProfit.expectedInvestemnt") }}
              </p>
            </van-col>
            <van-col span="12" style="text-align: right">
              <p class="profitValue">$ {{ item.estimated_repay_amount }}</p>
            </van-col>
          </van-row>

          <!-- --------- estimated repay time ------ -->
          <!-- <van-row style="padding-top: 25px">
            <van-col span="12">
              <p class="profitTopic">
                {{ $t("ownProfit.estimatedRepayTime") }}
              </p>
            </van-col>
            <van-col span="12" style="text-align: right">
              <p class="profitValue">
                {{ getDate(item.estimated_repay_time) }}
              </p>
            </van-col>
          </van-row> -->
          <!-- --------- investment status ------ -->
          <!-- <van-row style="padding-top: 25px">
            <van-col span="12">
              <p class="profitTopic">{{ $t("ownProfit.investStatus") }}</p>
            </van-col>
            <van-col span="12" style="text-align: right">
              <p class="profitValue">{{ item[lang] }}</p>
            </van-col>
          </van-row> -->
          <!-- --------- repay amount ------ -->
          <van-row style="padding-top: 25px" v-if="item.status === 1">
            <van-col span="12">
              <p class="profitTopic">{{ $t("ownProfit.repayAmount") }}</p>
            </van-col>
            <van-col span="12" style="text-align: right">
              <p class="profitValue">${{ item.repay_amount }}</p>
            </van-col>
          </van-row>
          <!-- --------- repay time ------ -->
          <van-row style="padding-top: 25px" v-if="item.status === 1">
            <van-col span="12">
              <p class="profitTopic">{{ $t("ownProfit.repayTime") }}</p>
            </van-col>
            <van-col span="12" style="text-align: right">
              <p class="profitValue">{{ getDate(item.repaytime) }}</p>
            </van-col>
          </van-row>
        </van-row>
      </van-row>
    </van-list>
  </div>
</template>

<script>
import Vue from "vue";
import Header from "../../components/header";
import { Icon, Col, Row, List } from "vant";
import Fetch from "../../utils/fetch";
import moment from "moment";
Vue.use(Icon).use(Row).use(Col).use(List);

export default {
  name: "teamprofit",
  components: {
    Header,
  },
  data() {
    return {
      lang: this.$i18n.locale || "en_us",
      investList: [],
      currentPage: 1,
      finished: false,
      loading: false,
    };
  },
  mounted() {
    this.getMyInvestmentsList();
  },
  methods: {
    getMyInvestmentsList() {
      this.loading = true;
      Fetch("/movie/ownProfit", {
        num: 5,
        page: this.currentPage,
      }).then((r) => {
        this.loading = false;
        this.currentPage++;
        if (r.data.length === 0) this.finished = true;
        this.investList = this.investList.concat(r.data);
      });
    },
    getDate(time) {
      return moment.unix(time).format("DD/MM/YYYY");
    },
  },
};
</script>

<style lang="less" scoped>
.home_wrap {
  width: 100%;
  min-height: 100vh;
  background: url("../images/common/BgImg.png");
  background-size: 100% 100%;
}

.topSection {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 30px 15px 20px;
}

.imageback {
  height: 40px;
  width: auto;
}

.profitBox {
  box-shadow: rgb(0 0 0 / 24%) 0px 3px 8px;
  border: 1px solid #ffffff;
  border-radius: 13px;
  padding: 10px 10px 20px;
  background: #ebebeb29;
}

.movieTopImage {
  object-fit: fill;
  width: 100%;
}

.profitTopic {
  color: #ffffff;
  font-size: 15px;
  font-weight: 700;
}

.profitValue {
  color: #ffffff;
  font-size: 15px;
}
</style>
